// Report sections that other modules' pages embed (#253): the signed-in
// employee's income summary and list on /account/my-incomes. Registered from
// `./index` at bootstrap; the page renders them by id and does not import
// Report. Contract: `src/lib/slots.tsx`. Registrations only; `load` stays a
// dynamic import.
import { registerSlot } from '@/lib/slots'

registerSlot({
    id: 'report.income-summary',
    load: () => import('./components/EmployeeIncome/components/Summary'),
})
registerSlot({
    id: 'report.income-list',
    load: () => import('./components/EmployeeIncome/components/Incomes'),
})
